import { komunikatBleduApi } from "../../lib/developer.js";
import { Button } from "../ui/Button.js";

/**
 * Komunikat nad danymi, gdy NIEUDANE (takze ciche) odswiezenie zostawilo na ekranie ostatnio pobrane dane. Mowi po polsku,
 * co sie stalo (kod z API albo "siec" przechodzi przez `komunikatBleduApi`, nigdy surowy), co widac mimo to (`ostatnie`) i
 * daje ponowienie od razu w tym samym miejscu, bez szukania przycisku "Odswiez" gdzie indziej.
 */
export function BladOdswiezania({
  czego,
  blad,
  ostatnie,
  onPonow,
}: {
  /** Dopelniacz: "listy", "stanu", "logow". */
  czego: string;
  /** Kod z ApiError.code albo "siec". */
  blad: string;
  /** Co zostalo na ekranie, np. "Widac ostatnio pobrane wiersze." */
  ostatnie: string;
  onPonow: () => void;
}): React.JSX.Element {
  return (
    <p className="developer-blad" role="status">
      Nie udało się odświeżyć {czego}. {komunikatBleduApi(blad)} {ostatnie}{" "}
      <Button onClick={onPonow}>Spróbuj ponownie</Button>
    </p>
  );
}
